import { useMediaLibrary } from "../components/MediaLibraryContext"

export function useSelectedMedia() {
  const { media, selectedMediaIds } = useMediaLibrary()

  return media.filter(({ id }) => selectedMediaIds.has(id))
}
